import { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuList } from '@mui/material';

import { Notification } from 'storage/notifications/notifications.model';
import { Url } from 'utils/urls';
import { Constant } from 'utils/consts';
import { useIsPaymentsUnavailable } from 'hooks';
import useNotifications, {
  isFinanceRelatedContext
} from 'pages/Dashboard/pages/Main/components/Notifications/useNotifications';
import { DesktopMenuAnchorContext } from '../../utils/desktopMenuAnchorContext';
import { MenuVisibilityContext } from '../../utils/menuVisibilityContext';
import { LinkStyled } from '../../styled/LinkStyled';
import NotificationItemWrapper from '../../styled/NotificationItemWrapper';
import NotificationItem from './NotificationItem';
import usePaymentNavigationState from '../../../../hooks/usePaymentNavigationState';
import { MenuItemWrapper } from './MenuItemWrapper';

const OverduePaymentsNotifications = ({
  notificationArray
}: {
  notificationArray: Notification[];
}) => {
  const { t } = useTranslation();
  const { getNotificationText } = useNotifications();
  const getPaymentNavigationState = usePaymentNavigationState();

  const { setNotificationAnchor } = useContext(DesktopMenuAnchorContext);
  const { setNotificationsVisible } = useContext(MenuVisibilityContext);
  const { isPaymentUnavailable } = useIsPaymentsUnavailable();

  const paymentsNotifications = useCallback(
    () =>
      notificationArray.map(({ context, messageKey, variant, name }, index) => {
        const isPayable = isFinanceRelatedContext(context);
        return isPayable ? (
          <MenuItemWrapper
            agreementId={context.sourceContractId}
            onClick={() => {
              setNotificationsVisible!(false);
              setNotificationAnchor!(null);
            }}
            key={`${context?.contractId}${name}`}
          >
            <LinkStyled
              to={
                isPaymentUnavailable || !isPayable
                  ? '#'
                  : `${Url.case}/${context.sourceContractId}${Url.payment}`
              }
              state={getPaymentNavigationState(+context.sourceContractId)}
              data-link
              $isNotificationLink
            >
              <NotificationItemWrapper>
                <NotificationItem
                  icon="exclamationMarkCircle"
                  color={variant}
                  text={getNotificationText(name, context, messageKey)}
                  isLinkTextAndIconHide={isPaymentUnavailable || !isPayable}
                  linkText={t('NOTIFICATIONS_LINK_PAY')}
                  fontWeight={700}
                  withoutBorder={
                    index === notificationArray.length - Constant.one
                  }
                />
              </NotificationItemWrapper>
            </LinkStyled>
          </MenuItemWrapper>
        ) : null;
      }),
    [notificationArray]
  );

  return <MenuList sx={{ py: 0 }}>{paymentsNotifications()}</MenuList>;
};

export default OverduePaymentsNotifications;
